import React from 'react'

const TransparencyIcon = (props) => {
  return (
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
    	 viewBox="0 0 511.801 511.801" {...props} >
    <g>
    	<g>
    		<g>
    			<path d="M242.004,458.953c-11.03-8.805-20.804-19.073-29.05-30.519c-3.228-4.481-9.477-5.498-13.959-2.268
    				c-4.48,3.228-5.496,9.478-2.268,13.959c9.31,12.923,20.345,24.516,32.798,34.458c1.843,1.471,4.045,2.185,6.232,2.185
    				c2.938,0,5.848-1.287,7.822-3.761C247.025,468.691,246.319,462.399,242.004,458.953z"/>
    			<path d="M414.96,205.104c12.197,7.052,23.385,15.753,33.251,25.861c1.96,2.007,4.558,3.015,7.157,3.015
    				c2.519,0,5.039-0.945,6.984-2.844c3.952-3.858,4.028-10.189,0.171-14.142c-11.142-11.414-23.775-21.239-37.552-29.205
    				c-4.784-2.764-10.898-1.129-13.663,3.651C408.544,196.222,410.18,202.34,414.96,205.104z"/>
    			<path d="M488.165,304.211c1.056,4.639,5.178,7.783,9.742,7.783c0.734,0,1.48-0.081,2.228-0.251
    				c5.385-1.226,8.757-6.584,7.532-11.97c-3.535-15.538-9.206-30.518-16.854-44.522c-2.646-4.848-8.725-6.634-13.568-3.984
    				c-4.848,2.646-6.632,8.722-3.984,13.568C480.024,277.222,485.039,290.47,488.165,304.211z"/>
    			<path d="M318.854,491.349c-14.009-1.736-27.69-5.393-40.666-10.866c-5.092-2.146-10.954,0.238-13.101,5.327
    				c-2.147,5.089,0.238,10.954,5.327,13.101c14.673,6.189,30.142,10.323,45.979,12.286c0.418,0.052,0.833,0.077,1.243,0.077
    				c4.974,0,9.284-3.708,9.911-8.771C328.228,497.022,324.335,492.028,318.854,491.349z"/>
    			<path d="M388.118,182.005c1.357-5.354-1.883-10.794-7.235-12.151c-10.824-2.744-21.94-4.424-33.159-5.044
    				C342.665,73.368,266.683,0.527,174,0.527c-95.944,0-174,78.056-174,174c0,92.852,73.105,168.946,164.781,173.755
    				c-0.269,1.034-0.384,2.126-0.301,3.251c1.178,15.934,4.535,31.589,9.977,46.53c1.479,4.061,5.313,6.581,9.397,6.581
    				c1.136,0,2.292-0.195,3.421-0.606c5.189-1.891,7.864-7.629,5.975-12.818c-4.813-13.214-7.781-27.063-8.824-41.161
    				c-0.047-0.632-0.158-1.243-0.314-1.833c87.725-5.052,158.227-75.383,163.553-163.035l0.009,0.009
    				c0.008-0.124,0.02-0.248,0.027-0.372c9.566,0.596,19.04,2.072,28.268,4.412C381.325,190.599,386.761,187.357,388.118,182.005z
    				 M184.344,328.183c5.113-76.688,66.625-138.199,143.313-143.313C322.543,261.558,261.031,323.07,184.344,328.183z
    				 M164.313,328.231l-0.011-0.006C83.883,323.208,20,256.188,20,174.527c0-84.916,69.084-154,154-154
    				c81.661,0,148.681,63.883,153.698,144.302l0.006,0.011C239.943,169.987,169.46,240.47,164.313,328.231z"/>
    			<path d="M502.288,336.68c-5.532-0.283-10.206,3.984-10.476,9.501c-0.689,14.129-3.308,28.05-7.779,41.375
    				c-1.757,5.236,1.063,10.905,6.299,12.662c1.056,0.354,2.128,0.522,3.183,0.522c4.18,0,8.076-2.641,9.479-6.821
    				c5.056-15.066,8.016-30.8,8.795-46.764C512.059,341.64,507.805,336.95,502.288,336.68z"/>
    			<path d="M479.181,422.624c-4.563-3.114-10.783-1.94-13.897,2.62c-7.949,11.645-17.461,22.154-28.27,31.238
    				c-4.229,3.553-4.775,9.861-1.222,14.089c1.978,2.354,4.809,3.566,7.66,3.566c2.271,0,4.555-0.77,6.429-2.345
    				c12.204-10.256,22.943-22.123,31.92-35.271C484.915,431.96,483.741,425.738,479.181,422.624z"/>
    			<path d="M401.373,478.927c-12.843,5.808-26.43,9.81-40.386,11.897c-5.462,0.816-9.228,5.907-8.41,11.369
    				c0.741,4.961,5.008,8.521,9.877,8.521c0.492,0,0.991-0.036,1.492-0.111c15.779-2.359,31.144-6.886,45.667-13.452
    				c5.032-2.275,7.268-8.2,4.992-13.232C412.329,478.887,406.405,476.656,401.373,478.927z"/>
    			<path d="M93.776,73.501C62.778,98.145,45,134.967,45,174.527c0,5.522,4.478,10,10,10s10-4.477,10-10
    				c0-33.427,15.025-64.543,41.223-85.371c4.323-3.437,5.042-9.728,1.604-14.051C104.391,70.782,98.1,70.063,93.776,73.501z"/>
    			<path d="M174.001,45.528c-12.155,0-24.189,1.69-35.768,5.025c-5.307,1.528-8.37,7.069-6.842,12.377
    				c1.261,4.382,5.26,7.235,9.604,7.235c0.916,0,1.848-0.127,2.774-0.393c9.779-2.816,19.951-4.244,30.232-4.244
    				c5.522,0,10-4.478,10-10C184.001,50.006,179.523,45.528,174.001,45.528z"/>
    		</g>
    	</g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    </svg>

  )
}

export default TransparencyIcon
